function init() {

    // resources subnav
    function subnavStick() {
        let headerHeight = jQuery('.o-header').outerHeight() + 1;

        jQuery(window).scroll(function(){
            let air = jQuery(window).scrollTop();
            if (air > headerHeight) {
               jQuery('body').addClass('fixed-subnav');
            } else {
                jQuery('body').removeClass('fixed-subnav');
            }
        })
    }
    function openSubnav() {
        jQuery('#subnavBrowse').stop().toggleClass('open');
        jQuery('#subnavWrapper .resource-archive__subnav-links').stop().slideToggle(260);
    }

    if ( jQuery('#subnavWrapper').length ) {
        subnavStick();

        jQuery(window).on('resize', function() {
            subnavStick();
            jQuery('#subnavWrapper .resource-archive__subnav-links').attr('style', '');
        });

        jQuery('#subnavBrowse').on('click', function() {
            openSubnav();
        })
    }

    // resource audio navigation
    function initiateVerbal() {
        jQuery('.beyondwords-player').attr('id', 'beyondWords');
        jQuery('.beyondwords-player').appendTo('#resourcePlayerWrapper')
        jQuery('#resourcePlayerWrapper').css('display', 'inline-block');
        
        jQuery('body').on('click', '#resourceListen', function() {
            jQuery('.beyondwords-player .play-pause-button').click();
            jQuery('#beyondWords').slideDown(260);
        });
    }

    if ( jQuery('#resourcePlayerWrapper').length ) {

        // not sure if the player is always in dom on load or is inserted via js - following should catch either case
        if ( jQuery('.beyondwords-player').length ) {
            initiateVerbal();
        }
        else {
            jQuery(document).one("DOMNodeInserted", ".beyondwords-player", function () {
                initiateVerbal();
            });
        }
    }

}

export { init as default } 